const javascriptCode = `

`;

const cssCode = `
    #\${values._meta.htmlID} img {
        border-radius: \${values.roundedCorners};
        width: \${values.width}px;
        height: \${values.height}px;
    }

    \${values.customCss}
`;

const htmlTemplate = `
    return "<img src='" + values.preview_url + "'/>";
`;

const exportTemplate = `
    return "<img src='" + values.image_url + "'/>";
`;

export default `
unlayer.registerTool({
    name: 'fixed_image',
    label: 'Fixed Image',
    icon: 'fa-image',
    supportedDisplayModes: ['web'],
    options: {
        default: {
            position: 1,
            options: {
                image_url: {
                    label: 'Image URL',
                    widget: 'text'
                },
                preview_url: {
                    label: 'Preview URL',
                    defaultValue: 'https://cdn.tools.unlayer.com/image/placeholder.png',
                    widget: 'text'
                }
            }
        },
        styles: {
            title: 'Styles',
            position: 2,
            options: {
                width: {
                    label: 'Width',
                    widget: 'counter',
                    defaultValue: 100
                },
                height: {
                    label: 'Height',
                    widget: 'counter',
                    defaultValue: 100
                },
                roundedCorners: {
                    label: 'Rounded Border',
                    widget: 'padding',
                    defaultValue: '0px'
                }
            }
        },
        custom: {
            title: 'Custom code',
            position: 3,
            options: {
                customCss: {
                    label: 'Custom CSS',
                    defaultValue: '',
                    widget: 'html'
                }
            }
        }
    },
    values: {},
    renderer: {
        Viewer: unlayer.createViewer({
            render(values) {${htmlTemplate}}
        }),
        exporters: {
            web: function (values) {${exportTemplate}}
        },
        head: {
            css: function (values) {
                return \`${cssCode}\`;
            },
            js: function (values) {
                return \`(function(){ ${javascriptCode} })();\`;
            }
        }
    }
});`;
